import { render, staticRenderFns } from "./headers.vue?vue&type=template&id=5c0e37a4&scoped=true&"
import script from "./headers.vue?vue&type=script&lang=js&"
export * from "./headers.vue?vue&type=script&lang=js&"
import style0 from "./headers.vue?vue&type=style&index=0&id=5c0e37a4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.7.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0e37a4",
  null
  
)

export default component.exports